import React from 'react'
import Header from './header'
import Question from '~/Common-Objects/UI/Question'
import i18n from '~/i18n'

export default function QuestionsStep2({ answers, setAnswers, errors }) {
    return (
        <div>
            <Header
                header={i18n.t('account:questions.step2.header')}
                subheader={i18n.t('account:questions.step2.subheader')}
            />
            <Question
                className='mar-b32'
                label={i18n.t('account:questions.step2.question1')}
                required={true}
                name='comfort'
                value={answers.comfort}
                onChange={(e) => setAnswers({ ...answers, comfort: e.target.value })}
                options={[
                    { label: i18n.t('account:questions.step2.options1.new'), value: "I'm new" },
                    { label: i18n.t('account:questions.step2.options1.some'), value: 'Some Experience' },
                    { label: i18n.t('account:questions.step2.options1.experienced'), value: 'Experienced' },
                    { label: i18n.t('account:questions.step2.options1.expert'), value: 'Expert' }
                ]}
                error={errors.comfort}
            />
            <Question
                label={i18n.t('account:questions.step2.question2')}
                required={true}
                name='importantToBusiness'
                value={answers.importantToBusiness}
                multiselect={true}
                onChange={(e) => setAnswers({ ...answers, importantToBusiness: e.target.value })}
                error={errors.importantToBusiness}
                options={[
                    { label: i18n.t('account:questions.step2.options2.template'), value: 'Email Templates' },
                    { label: i18n.t('account:questions.step2.options2.automation'), value: 'Automation Tasks' },
                    { label: i18n.t('account:questions.step2.options2.ai'), value: 'AI Content Assistant' },
                    { label: i18n.t('account:questions.step2.options2.tracking'), value: 'Tracking Visitors' },
                    { label: i18n.t('account:questions.step2.options2.social'), value: 'Social Posting' },
                    { label: i18n.t('account:questions.step2.options2.sms'), value: 'SMS Marketing' },
                    { label: i18n.t('account:questions.step2.options2.performance'), value: 'Campaign Performance' },
                    { label: i18n.t('account:questions.step2.options2.chat'), value: 'Web Chat' }
                ]}
            />
        </div>
    )
}
